<template>
	<AppDialog
		closeTop="-30"
		width="625"
		height="700"
		closeRight="-2"
		disable-max-width
		ref="dialog_container"
		:dialogName="'AnalyticsEventCustomEventEditDialog'"
	>
		<div class="p-[30px] h-[750px] flex flex-col justify-between">
			<div>
				<v-row no-gutters align="center" class="list_item">
					<AnemicButton class="back-button mr-[5px]" width="25" height="25" @click="close" fab x-small>
						<AppIcon name="back" />
					</AnemicButton>
					<v-col cols="auto">
						<div class="w-[40px] h-[40px] border-[#D9D9D9] border rounded-md grid">
							<v-img class="place-self-center" :src="currentProvider?.icon" :width="20" />
						</div>
					</v-col>
					<v-col class="pl-3 h-full justify-between flex-col mb-[8px]">
						<h3 class="d_name light">
							<span class="text-[20px] font-semibold text-[#1B1C21]">Set up event template</span>
						</h3>
						<p class="display-flex flex-row flex-align-center text-[12px] text-[#646E87]">
							Send to "{{ currentConfiguration?.title }}" - {{ currentProvider?.provider_name }}
						</p>
					</v-col>
					<v-col cols="12" class="mt-3 mb-1"> </v-col>
				</v-row>
			</div>
			<EventEdit
				@addEvent="addEvent"
				:event="event"
				@editEvent="editEvent"
				:showCustomParams="showCustomParams"
				:showIdentifier="showIdentifier"
			/>
		</div>
	</AppDialog>
</template>

<script>
import EventEdit from './AnalyticsEventTrackingItemDialog/EventEdit';
import { Providers } from '@/components/dialogs/AnalyticsEventTrackingSettingsDialog/provider_id_names';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import {
	addAnalyticsEvent,
	editAnalyticsEvent,
	fetchAnalyticsConfigurations,
	fetchAnalyticsProviders,
} from '@/store/modules/analyticsProvider/actions';
import { useAnalyticsConfigurations, useAnalyticsProviders } from '@/store/modules/analyticsProvider/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';

const NO_CUSTOM_PARAM_SLUGS = [Providers.LINKEDIN];
const IDENTIFIER_SLUGS = [Providers.LINKEDIN, Providers.X];

export default {
	name: 'AnalyticsEventCustomEventEditDialog',
	props: { event: { type: Object }, provider: { type: Object }, pixelConfiguration: { type: Object }, paramData: { type: Object } },
	components: {
		EventEdit,
		AppDialog,
	},
	computed: {
		...mapGettersShorthand({ useAnalyticsProviders, useAnalyticsConfigurations }),
		showCustomParams() {
			return !NO_CUSTOM_PARAM_SLUGS.includes(this.currentProvider.slug);
		},
		showIdentifier() {
			return IDENTIFIER_SLUGS.includes(this.currentProvider.slug);
		},
	},
	methods: {
		...mapActionsShorthand({ addAnalyticsEvent, editAnalyticsEvent, fetchAnalyticsConfigurations, fetchAnalyticsProviders }),
		close() {
			AppDialogManagerService.closeCurrentDialog();
			this.openConfigurationDialog();
		},
		openConfigurationDialog() {
			AppDialogManagerService.openAnalyticsEventTrackingItemDialog({ pixelConfiguration: this.currentConfiguration });
		},
		async addEvent(event) {
			try {
				await this.addAnalyticsEvent({
					analyticsEvent: event,
					analyticsConfiguration: this.currentConfiguration,
				});
				this.close();
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
		async editEvent(event) {
			try {
				await this.editAnalyticsEvent({
					analyticsEvent: event,
					analyticsConfiguration: this.currentConfiguration,
					id: event.id,
				});
				this.close();
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
	data() {
		return {
			currentConfiguration: this.pixelConfiguration || null,
			currentProvider: this.provider || null,
		};
	},
	async created() {
		if (!this.pixelConfiguration && !this.provider) {
			await this.fetchAnalyticsConfigurations();
			await this.fetchAnalyticsProviders();
			const configurationId = this.paramData.configuration;
			this.currentConfiguration = this.useAnalyticsConfigurations.find((configuration) => configuration.id === configurationId);
			this.currentProvider = this.useAnalyticsProviders[this.currentConfiguration.analytics_provider];
		}
	},
};
</script>

<style scoped lang="scss">
div > button.add-event-button {
	color: #6060f7 !important;
	font-size: 14px !important;
	border-color: #6060f7 !important;
	text-transform: none !important;
	border-radius: 8px !important;
}
</style>
